import PropTypes from 'prop-types';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: '76px',
        maxHeight: '76px',
        width: 'initial',
        overflow: 'hidden',
        paddingTop: '10px',
        paddingBottom: '10px',
        paddingLeft: open ? '20px' : 0,
        paddingRight: open ? '16px' : 0,
        borderBottom: '1px solid',
        borderBottomColor: 'divider',
        background: 'linear-gradient(180deg, rgba(0,0,0,0.02) 0%, rgba(0,0,0,0) 100%)'
      }}
    >
      <Logo isIcon={!open} sx={open ? { maxWidth: '100%' } : { width: 34, height: 34 }} />
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };